import React, { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../../context/NetworkContext";
import { useShowAlert } from "../../../../context/AlertContext";
import AxiosInstance from "../../../../utils/AxiosInstance";
import handleError from "../../../../constants/handleError";
import AddStock from "./AddStock";
import { usePermission } from "../../../../context/PermissionContext";
import Messages from "../../../../constants/Messages";
import StockOut from "../StockOut";
import useKeyboardTableNavigation from "../../../../constants/useKeyboardTableNavigation";
import { useContextApi } from "../../../../context/ContextApi";
import Table from "../../../../constants/Table";
import BarcodeGenerator from "../../product/BarCode";
import uRLs from "../../../../utils/baseUtils";
import { toPrimaryQuantity, toSecondaryQuantity } from "@heartinz/finance";
import { BarcodeIcon, DeleteIcon } from "../../../../constants/Icons";

const SubStock = ({ isActive }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isStockData, setStockData] = useState([]);
  const perPage = 10;
  const { getColor } = useContextApi();
  const [isAnyInputFocused, setIsAnyInputFocused] = useState(false);
  const [isStockOutData, setStockOutData] = useState("");
  const [isStockOutModalOpen, setStockOutModalOpen] = useState(false);
  const [recenetStock, setRecentStock] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [matchOpen, setMatchOpen] = useState(false);
  const [newOpen, setNewOpen] = useState(false);
  const [noteSuggest, setNoteSuggest] = useState([]);
  const [noteOpen, setNoteOpen] = useState(false);
  const hasFetched = useRef(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [brandSuggest, setBrandSuggest] = useState([]);
  const { permission, hasPermission, globelPopupOpen } = usePermission();

  const handleNoteOpen = (status) => {
    setNoteOpen(status);
  };

  const primaryQuanity = (quanity, unitData) => {
    const qty = toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  };

  const handleRecentStock = async (page = 0) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/stock?pageno=${page + 1}&limit=${perPage}`
      );
      setStockData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };
  console.log("recenetStock", recenetStock);
  const handleSetRecentStock = (
    stockIn,
    stockLeft,
    title,
    code,
    salePrice,
    taxpercentage,
    landingcost,
    stockid,
    productid,
    stocklinkid,
    unitConfig,
    isSecondaryUnit
  ) => {
    const updatedProduct = {
      stockIn,
      stockLeft,
      title,
      code,
      saleprice: CurrencyConverter.toSubunit(salePrice, "INR"),
      taxpercentage,
      landingcost,
      stockid,
      productid,
      stocklinkid,
      unitConfig,
      isSecondaryUnit,
    };
    setStockData((prev) => [updatedProduct, ...prev.slice(0, 9)]);

    setRecentStock((prev) => {
      const prevs = localStorage.getItem("recentDirectStocks");
      const updatedStocks = [updatedProduct, ...prev.slice(0, 9)]; // Keep only latest 10
      localStorage.setItem("recentDirectStocks", JSON.stringify(updatedStocks));
      return updatedStocks;
    });
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeStockOutModal = () => {
    setStockOutModalOpen(false);
    setStockOutData("");
  };

  const secondaryQuanity = (quanity, unitData) => {
    const qty = toSecondaryQuantity(quanity, unitData);
    return qty?.secondaryQty;
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleStockTrash = async (
    updatedData,
    quantity,
    remarks,
    selectedUnit
  ) => {
    console.log(updatedData, quantity);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData.productid,
        stockid: updatedData.stockid,
        // stocklid: updatedData.stocklid,
        ...(remarks && { remarks }),
        quantity: Number(
          // updatedData?.isSecondaryUnit &&
          selectedUnit === updatedData?.unitConfig?.secondaryUnitCode
            ? primaryQuanity(quantity, updatedData?.unitConfig)
            : quantity
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData.stocklinkid}`,
        { data }
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.stocklinkid === updatedData.stocklinkid
            ? {
                ...item,
                stockLeft: Number(
                  (item.stockLeft - updatedData.quantity).toFixed(2)
                ),
              }
            : item
        )
      );

      //   setRecentStock((prevStock) =>
      //   prevStock.map((item) =>
      //     item.productid === updatedData.productid
      //       ? {
      //           ...item,
      //           stockLeft: item.stockLeft - updatedData.quantity,
      //         }
      //       : item
      //   )
      // );

      setRecentStock((prev) => {
        // const savedStocks = JSON.parse(localStorage.getItem("recentDirectStocks")) || [];
        console.log(prev);
        const updatedStocks = prev.map((item) =>
          item.stocklinkid === updatedData.stockLinkId
            ? {
                ...item,
                stockLeft: Number(
                  (item.stockLeft - updatedData.quantity).toFixed(2)
                ),
              }
            : item
        );
        console.log(updatedStocks);
        localStorage.setItem(
          "recentDirectStocks",
          JSON.stringify(updatedStocks)
        );
        return updatedStocks;
      });

      showAlert("success", Messages.SUCCESS.STOCK_TRASHED);
      closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBrandSuggest = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/brand/suggestion`
      );
      const result = response?.data?.results;
      setBrandSuggest(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  // useEffect(() => {
  //     handleRecentStock();
  // }, []);
  const handleSearchOpen = (status) => {
    setSearchOpen(status);
  };

  const handleNewOpen = (status) => {
    setNewOpen(status);
  };
  const handleMatchOpen = (status) => {
    setMatchOpen(status);
  };

  useKeyboardTableNavigation({
    modals: {
      searchOpen,
      matchOpen,
      isStockOutModalOpen,
      globelPopupOpen,
      newOpen,
      isAnyInputFocused,
    },
    onEnter: openDeleteTrashModal,
  });

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestNote();
    handleBrandSuggest();
  }, []);

  useEffect(() => {
    const savedStocks =
      JSON.parse(localStorage.getItem("recentDirectStocks")) || [];
    setRecentStock(savedStocks);
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="row">
            <div className="col-lg-5">
              <h6 className="card-title ">Add Direct Stock</h6>
              <AddStock
                isActive={isActive}
                ListRecentStock={handleRecentStock}
                handleSetRecentStock={handleSetRecentStock}
                searchOpen={handleSearchOpen}
                matchOpen={handleMatchOpen}
                newOpen={handleNewOpen}
                noteOpenStatus={handleNoteOpen}
                noteSuggests={noteSuggest}
                setIsAnyInputFocused={setIsAnyInputFocused}
                brandSuggest={brandSuggest}
                setBrandSuggest={setBrandSuggest}
              />
            </div>
            <div className="col-lg-7">
              <h6 className="card-title ">Recently Added Direct Stock</h6>
              <div className="card radius-10 mb-0 mt-3">
                <div className="card-body px-0">
                  <Table
                    loading={isLoading}
                    data={recenetStock}
                    trClass={true}
                    onRowClick={(item, index) =>
                      openDeleteTrashModal(item, index)
                    }
                    columns={[
                      {
                        label: "SKU Code",
                        render: (item) => (
                          <span className="badge rounded-pill bg-label-navy">
                            {item.code}
                          </span>
                        ),
                      },
                      {
                        label: "Title",
                        render: (item) => (
                          <span className="text-heading fw-medium text-wrap">
                            {item?.title}
                          </span>
                        ),
                      },
                      {
                        label: "Sale Price",
                        render: (item) => (
                          <>
                            {" "}
                            ₹
                            {CurrencyConverter.toCurrency(
                              item.saleprice,
                              "INR"
                            )}
                          </>
                        ),
                      },
                      {
                        label: "Landingcost",
                        render: (item) => (
                          <span className="badge bg-label-peace">
                            ₹
                            {CurrencyConverter.toCurrency(
                              item?.landingcost || 0,
                              "INR"
                            )}
                          </span>
                        ),
                      },
                      {
                        label: "Stock In",
                        render: (item) => (
                          <span className="badge bg-label-spring">
                            {Number(
                              item?.isSecondaryUnit
                                ? secondaryQuanity(
                                    item.stockIn,
                                    item?.unitConfig
                                  )
                                : item?.stockIn
                            )}
                            <span className="font-11 ms-1">
                              {(() => {
                                const unitCode = item?.isSecondaryUnit
                                  ? item?.unitConfig?.secondaryUnitCode
                                  : item?.unitConfig?.primaryUnitCode;

                                // return unitCode !== "unit" ? unitCode : "";
                                return unitCode ;
                              })()}
                            </span>
                          </span>
                        ),
                      },
                      {
                        label: "Stock Left",
                        render: (item) => (
                          <span className="badge bg-label-space">
                            {Number(
                              item?.isSecondaryUnit
                                ? secondaryQuanity(
                                    item.stockLeft,
                                    item?.unitConfig
                                  )
                                : item?.stockLeft
                            )}
                            <span className="font-11 ms-1">
                              {(() => {
                                const unitCode = item?.isSecondaryUnit
                                  ? item?.unitConfig?.secondaryUnitCode
                                  : item?.unitConfig?.primaryUnitCode;

                                // return unitCode !== "unit" ? unitCode : "";
                                return unitCode ;
                              })()}
                            </span>
                          </span>
                        ),
                      },
                      {
                        label: "Actions",
                        render: (item, index) => (
                          <div className="order-actions opacity-0 opacity-md-100">
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClickBarcode(item);
                              }}
                            >
                              <BarcodeIcon/>
                            </button>
                            <button
                              type="button"
                              className="btn-label-danger shadow-none"
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteTrashModal(item, index);
                              }}
                            >
                              <DeleteIcon/>
                            </button>
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
          {isStockOutModalOpen && (
            <StockOut
              data={isStockOutData}
              onClose={closeStockOutModal}
              onEdit={handleStockTrash}
              isBtnLoading={isBtnLoading}
            />
          )}
          {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
            <BarcodeGenerator
              barcodeValue={selectedBarcode.code}
              product={selectedBarcode}
              onClose={() => setShowBarcodeModal(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default SubStock;
